var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'relative animation-ready'},[_c('div',[_vm._t("header")],2),_c('transition-expanded',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.active),expression:"active"}]},[_vm._t("body")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }